<template>
  <div
    class="modal"
    :class="{ 'is-active': isActive }"
    @keyup.esc="$emit('close-modal')"
  >
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <div>
          <p class="modal-card-title">{{ title }}</p>
        </div>
      </header>
      <section class="modal-card-body">
        <div v-html="formattedText"></div>
        <div class="btn-wrapper">
          <button class="button primary">
            <a :href="setupInstructionLink" target="_blank">{{ button }}</a>
          </button>
        </div>
        <button class="delete" aria-label="close" @click="$emit('close-modal')">
          <i class="mdi mdi-close"></i>
        </button>
      </section>
    </div>
  </div>
</template>

<script>
import { SETUP_INSTRUCTION_LINK } from './constants';
export default {
  name: 'ActionRequiredModal',
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    button: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      setupInstructionLink: SETUP_INSTRUCTION_LINK,
      formattedText: this.text
        .split('\n')
        .map(val => `<p class="mb-4 has-text-centered">${val}</p>`)
        .join(''),
    };
  },
};
</script>

<style lang="scss" scoped>
@import '~scss/utilities/initial-variables.scss';
@import '~scss/utilities/derived-variables.scss';
.modal-card {
  width: 800px;
}
.modal-card-head {
  justify-content: center;
  background-color: $background;
}
.modal-card-title {
  font-size: 1.5rem;
  font-weight: 500;
  text-align: center;
}

.modal-card-body {
  background-color: $background;

  .btn-wrapper {
    text-align: center;
    .button {
      border-radius: 0.125rem;
      font-size: 0.75rem;
      background-color: $grey-lighter;
      color: $black;
      text-transform: uppercase;
      letter-spacing: 0.125rem;
      text-align: center;
      line-height: 1;
      padding: 0.8125rem 1.625rem;
      font-weight: bold;

      &.primary {
        background-color: $primary-blue-button;
        color: $white;
      }
    }
  }
  .delete {
    position: absolute;
    top: 1.25rem;
    right: 1.25rem;
    cursor: pointer;
  }
}
</style>
